export default __webpack_public_path__ + "static/media/back.947c9706.jpg";